import TableHeader from '@tiptap/extension-table-header';

import WsColors from '../../../WsColors';

export const CustomTableHeader = TableHeader.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      backgroundColor: {
        default: WsColors.DefaultHeaderCellColor,
        parseHTML: (element) => element.style.backgroundColor || WsColors.DefaultHeaderCellColor,
        renderHTML: (attributes) => {
          return {
            style: `background-color: ${attributes.backgroundColor}`,
          };
        },
      },
      customStyle: {
        default: null,
        renderHTML: () => {
          return {
            style:
              'min-width: 48px; border: 2px solid #ced4da; padding: 3px 5px; vertical-align: top; box-sizing: border-box; position: relative; white-space: normal; word-break: break-word; overflow-wrap: anywhere;',
          };
        },
      },
    };
  },
});
